var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 1.6665C5.40508 1.6665 1.66675 5.40484 1.66675 9.99984C1.66675 14.5948 5.40508 18.3332 10.0001 18.3332C14.5951 18.3332 18.3334 14.5948 18.3334 9.99984C18.3334 5.40484 14.5951 1.6665 10.0001 1.6665ZM10.8334 14.9998H9.16675V13.3332H10.8334V14.9998ZM11.6467 10.929C11.4834 11.0607 11.3259 11.1865 11.2009 11.3115C10.8609 11.6507 10.8342 11.959 10.8334 11.9723V12.0832H9.16675V11.944C9.16675 11.8457 9.19091 10.9632 10.0217 10.1323C10.1842 9.96984 10.3859 9.80484 10.5976 9.63317C11.2092 9.13734 11.6109 8.77567 11.6109 8.27734C11.6012 7.85635 11.4272 7.45588 11.126 7.1616C10.8248 6.86732 10.4204 6.70262 9.99926 6.70273C9.57816 6.70284 9.17383 6.86775 8.87278 7.16218C8.57174 7.45662 8.39788 7.85718 8.38841 8.27817H6.72175C6.72175 6.47067 8.19258 4.99984 10.0001 4.99984C11.8076 4.99984 13.2784 6.47067 13.2784 8.27817C13.2784 9.609 12.2959 10.4032 11.6467 10.929Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.2887991727a6025115d8ad4db6ff87a6.svg";
export { ForwardRef as ReactComponent };